import React, { FC } from "react";
import {
  Autocomplete,
  Grid,
  InputAdornment,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormSuggestionTextField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const inputRender = (isInGrid: boolean) => {
    return (
      <Autocomplete
        freeSolo
        autoHighlight
        clearOnBlur={false}
        options={(props.suggestions || []) as string[]}
        value={props.value || ""}
        inputValue={props.value || ""}
        onInputChange={(_event, newInputValue, reason) => {
          if (reason === "reset") return;

          props.onChange?.({
            target: {
              id: props.id,
              value: newInputValue,
            },
          });
        }}
        onChange={(_event, newValue) => {
          props.onChange?.({
            target: {
              id: props.id,
              value: newValue || "",
            },
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={props.inputRef}
            style={{
              marginTop: props?.isNonMarginTop ? "0px" : "",
            }}
            hiddenLabel
            variant="outlined"
            placeholder={props.placeholder}
            name={props?.id}
            label=""
            margin="normal"
            fullWidth
            InputProps={{
              ...params.InputProps,
              ...props?.InputProps,
              startAdornment: props?.prefixIcon && (
                <InputAdornment
                  sx={{ width: "6px" }}
                  position="start"
                >
                  {props?.prefixIcon}
                </InputAdornment>
              ),
              sx: {
                background: props?.disableBackground
                  ? props?.disableBackground
                  : "#fff",
                overflow: "hidden",
                ...props?.InputProps?.sx,
                ...(props?.isRounded && {
                  borderRadius: "50px",
                }),

                ...(isInGrid && {
                  "& input:-webkit-autofill": {
                    WebkitBoxShadow:
                      "0 0 0 1000px #fff inset",
                    WebkitTextFillColor: "#000",
                    background: "transparent",
                    height: "10px !important",
                    overflow: "hidden",
                  },
                  "&.Mui-disabled": {
                    backgroundColor:
                      props?.disableBackground && "#eeecef",
                    color: "black",
                    "-webkit-text-fill-color":
                      "rgba(0, 0, 0, 1) !important",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    top: "-5px",
                    background: "transparent",
                  },
                }),
              },
              onBlur: (e: any) => {
                props?.onBlur && props?.onBlur(e);
              },
            }}
            inputProps={{
              ...params.inputProps,
              style: {
                ...props?.inputProps?.style,
              },
            }}
            error={props.error}
            helperText={props.helperText}
          />
        )}
      />
    );
  };

  return (
    <>
      {props?.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={
              props?.md
                ? props?.firstColmd
                  ? props?.firstColmd
                  : 1.5
                : 5
            }
            className={classes.labelBox}
            sx={{
              marginTop: props?.isNonMarginTop
                ? "0px !important"
                : "",
              backgroundColor:
                props?.lblBackgroundColor ?? "",
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "18px",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span
                    style={{
                      color: "red",
                      fontWeight: 500,
                    }}
                  >
                    *
                  </span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>

          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              ...props?.GridFieldStyle,
              padding: "0px",
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : props?.label &&
        props?.inSingleGridForm ? (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{
            display: "block",
            gap: 2,
            ...props?.GridFieldStyle,
          }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "left !important",
              }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span
                  style={{
                    color: "red",
                    fontWeight: 500,
                  }}
                >
                  *
                </span>
              )}
            </InputLabel>
          </Tooltip>

          {inputRender(true)}
        </Grid>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormSuggestionTextField;